export const code = `import React, { Fragment, useState, useRef } from "react";
import { Modal, Button, Message, Input } from "@arco-design/web-react";
import axios from "axios";
import { ACTIVITY_ID, PUBLIC_TOKEN } from "../constants";

function AuthPC() {
  const [isLoading, setIsLoading] = useState(false);
  const [showLogin, setShowLogin] = useState(true);
  const [userName, setUserName] = useState("");
  const liveSDKInstance = useRef(null);
  const isFirstLogin = useRef(true);

  const initSDK = (token, mode) => {
    if (token) {
      liveSDKInstance.current?.destroy();
      liveSDKInstance.current = new window.ByteLiveWebSDK({
        activityId: ACTIVITY_ID,
        token: token,
        service: "liveTest",
        mode: mode ?? 2,
        modules: [
          {
            id: "player",
            mode: "player",
          },
          {
            id: "menu",
            mode: "menu",
            menu: ["comment", "imagetext", "cardlist"],
          },
          {
            id: "menu2",
            mode: "menu",
            menu: ["bandcontent"],
          },
        ],
        options: {
          origin: "https://live.byteoc.com",
          backgroundTransparent: true,
          pcPlayerHeader: true,
          disabledLogin: true,
          saveUserInfo: false
        },
      });
      liveSDKInstance.current.on("permission.need", openLogin);
    } else {
      Message.error("token 异常");
    }
  };

  const openLogin = () => {
    isFirstLogin.current = false;
    setUserName("");
    setIsLoading(false);
    setShowLogin(true);
  };

  const onLogin = () => {
    if (!userName) {
      Message.info("请输入昵称");
      return;
    }
    setIsLoading(true);
    axios
      .post("https://live.byteoc.com/demo/sdkapi/invoke/cloudTestSdkToken", {
        ActivityId: ACTIVITY_ID,
        Mode: 2,
        Nickname: userName,
        UserIdStr: "" + new Date().getTime() + Math.floor(Math.random() * 100),
      })
      .then((res) => {
        if (res.data?.Result?.Token) {
          setShowLogin(false);
          initSDK(res.data?.Result?.Token);
        } else {
          throw new Error();
        }
      })
      .catch(() => {
        Message.error("接口错误，请重试");
      });
  };

  const onPublicLogin = () => {
    setShowLogin(false);
    initSDK(PUBLIC_TOKEN, 1);
  };

  return (
    <div>
      <Modal
        title="自定义登录方式"
        visible={showLogin}
        footer={
          <Fragment>
            {isFirstLogin.current && (
              <Button loading={isLoading} onClick={onPublicLogin}>
                游客进入
              </Button>
            )}
            <Button loading={isLoading} onClick={onLogin} type="primary">
              登录
            </Button>
          </Fragment>
        }
        autoFocus={false}
        focusLock={true}
        closable={!isFirstLogin.current}
        onCancel={() => setShowLogin(false)}
      >
        <p>
          支持接入任何用户体系，使用昵称和 UID 调用企业直播 openAPI
          获取带有用户信息的token，随后用该token初始化SDK。
          <br />
          支持公开权限初始化SDK，在评论或抽奖等需要用户信息的场景再进行昵称注册或接入自定义用户体系。
        </p>
        <Input
          style={{ width: 350, marginTop: 24, marginLeft: 65 }}
          allowClear
          placeholder="请输入昵称"
          maxLength={30}
          onChange={setUserName}
        />
      </Modal>
    </div>
  );
}

export default AuthPC;
`